module.exports = __webpack_public_path__ + "media/6_3.ff07e125.wav";